import { CustomHorizonRadioStyled } from './styled';

interface IProps {
  checked: string | number;
  onChange: (value: string | number) => void;
  options: (string | number)[];
}

const CustomHorizonRadio = ({ checked, onChange, options }: IProps) => {
  return (
    <CustomHorizonRadioStyled>
      {options.map((option) => (
        <div
          key={option}
          className={`custom-horizon-radio-item ${checked === option ? 'checked' : ''}`}
          onClick={() => onChange(option)}
        />
      ))}
    </CustomHorizonRadioStyled>
  );
};

export default CustomHorizonRadio;
